import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bool, func, number } from "prop-types";

const ScheduleExpander = ({ schedule, expanded, onExpand }) => (
  <FontAwesomeIcon
    data-test-id={`expand-schedule-${schedule}`}
    icon={expanded ? faAngleDown : faAngleRight}
    onClick={() => onExpand(schedule)}
    className="pr-1"
    style={{ cursor: "pointer" }}
  />
);

ScheduleExpander.propTypes = {
  schedule: number,
  expanded: bool,
  onExpand: func,
};

export { ScheduleExpander };
